define('modules/form_editor/behaviours/has_toolbar',['require','exports','module','../views/inline_toolbar'],function(require, exports, module){
  "use strict";
  var FieldToolbarView = require("../views/inline_toolbar");

  /* Mix common inline toolbar behaviour into form fields */
  var toolbarEvents = {
    "click .js-duplicate": "duplicate",
    "click .js-move-down": "moveDown",
    "click .js-move-up": "moveUp",
    "click .js-remove": "removeField"
  };

  module.exports = {
    duplicate: function(e){
     this._cancelEvent(e);
     this.vent.trigger("form:duplicate");
    },
    moveDown: function(e){
      this._cancelEvent(e);
      this.vent.trigger("form:moveDown");
    },
    moveUp: function(e){
      this._cancelEvent(e);
      this.vent.trigger("form:moveUp");
    },
    removeField: function(e){
      this._cancelEvent(e);
      this.vent.trigger("form:remove");
    },
    _cancelEvent: function(e){
      e.preventDefault();
      e.stopPropagation();
    },
    toggleSelected: function(isSelected){
      this.$el.toggleClass("item-is-edited", !!isSelected);
      if (!!isSelected) {
        this._inlineToolbar = new FieldToolbarView({ model: this.model });
        this.$el.prepend(this._inlineToolbar.render().$el);
      } else if (this._inlineToolbar) {
        this._inlineToolbar.remove();
        delete this._inlineToolbar;
      }
    },
    mixed: function(klass, proto) {
      proto.events = _.extend(proto.events || {}, toolbarEvents);
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init){
        this.listenTo(this.model, "item:selected", this.toggleSelected);
        return init.apply(this, _.rest(arguments));
      });
    }
  };

});

